// removed by extract-text-webpack-plugin
module.exports = {"intro":"src-pages----styles-module---intro---2Dr5P","link":"src-pages----styles-module---link---3nvcj"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/styles.module.css
// module id = 329
// module chunks = 213534597649335